var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22 8.8678H11.5983H5.72205e-06V7.49994V6.13208H11.5983H22L23.1965 7.49994L22 8.8678Z","fill":"#EB0045","key":0}),React.createElement("path",{"d":"M23.1965 0.5H19.7039L25.2112 7.49272L19.7039 14.5H23.1965L28.7039 7.49272L23.1965 0.5Z","fill":"#EB0045","key":1})]);
}

Arrow.defaultProps = {"width":"29","height":"15","viewBox":"0 0 29 15","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
